import React from 'react';
import AudiHeader from './components/audi/AudiHeader';
import AudiFooter from './components/audi/AudiFooter';

class Layout extends React.Component {
    render() {
        return (
            <div>
                <div className="outer-wrapper">

                    <AudiHeader api={process.env.RAZZLE_MYAUDI_CMS} />

                    <main id="main">
                        {this.props.children}
                    </main>

                </div>
                <AudiFooter api={process.env.RAZZLE_MYAUDI_CMS} />
            </div>
        );
    }
}

export default Layout;
